

const LoadingComponent = () => {
    return(
        <div className="loading-component">

        </div>
    )
}

export default LoadingComponent;